module.exports = __webpack_public_path__ + "static/CumpleExsis2x-dc381ab5e95ded34d794586f2cee1bdb.png";